const AUTO_SELECTED_AREA_IDS = {
  115: 146, // Chelsea => Hudson Yards
  117: 106 // East Village => Stuyvensant Town/PCV
};

export { AUTO_SELECTED_AREA_IDS };
